import {V1SolidworksConfigurationIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import EnlilAxios from "../../../../util/EnlilAxios";



class SolidworksConfigurationEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        EnlilAxios({
            method: "GET",
            url: "t2/v1/solidworks_configurations",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.SolidworksConfiguration-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1SolidworksConfigurationIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.SolidworksConfiguration-001";
        payload.ShifamedMessage.SolidworksConfiguration = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t2/v1/solidworks_configurations",
            json: true,
            data: payload,
            headers: {},
        };
        this.notifyUpdateStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1SolidworksConfigurationIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let SolidworksConfiguration = {};

        SolidworksConfiguration["USID"] = this.getAttributeValue("USID");
        SolidworksConfiguration["PartDocumentTypeUSID"] = this.getAttributeValue("PartDocumentTypeUSID");
        SolidworksConfiguration["PartFormDocumentRevisionUSID"] = this.getAttributeValue("PartFormDocumentRevisionUSID");
        SolidworksConfiguration["AssemblyDocumentTypeUSID"] = this.getAttributeValue("AssemblyDocumentTypeUSID");
        SolidworksConfiguration["AssemblyFormDocumentRevisionUSID"] = this.getAttributeValue("AssemblyFormDocumentRevisionUSID");
        SolidworksConfiguration["ARDocumentTypeUSID"] = this.getAttributeValue("ARDocumentTypeUSID");
        SolidworksConfiguration["ARFormDocumentRevisionUSID"] = this.getAttributeValue("ARFormDocumentRevisionUSID");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.SolidworksConfiguration-001";
        payload.ShifamedMessage.SolidworksConfiguration = SolidworksConfiguration;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t2/v1/solidworks_configurations",
            json: true,
            data: payload,
            headers: {},
        };
        this.notifyInsertStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1SolidworksConfigurationIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

}

export default SolidworksConfigurationEnterpriseComponent;